import { FormValidationFunction } from '@/views/interfaces/vuetify/form.interface';
import { ShiftDayType } from '@/services/Calendar/ShiftType/Interfaces';

export class CreateShiftTypeForm {
  public name: string = '';
  public shortName: string = '';
  public duration: number = 0;
  public startAt: string = '';
  public endAt: string = '';
  public breakDuration: number;
  public textColor: string = '#000';
  public background: string = '#fff';
  public dayType: string = ShiftDayType.WORK;
  public automations: boolean = false;

  public rules: { [key: string]: FormValidationFunction[] } = {
    name: [
      (v: string) => !!v || 'Name field is required.',
    ],
    shortName: [
      (v: string) => !!v || 'Short name field is required.',
      (v: string) => v.length < 5 || 'The short name field must contain up to two characters.',
    ],
    duration: [
      (v: number) => !(v < 0 || v > 24) || 'The duration must be between 0 and 24.',
    ],
    startAt: [
      (v: string) => !!v || 'Start At field is required.',
      (v: string) => !v || /^(?:0?|1|2(?=[0-3]))\d:(?:0?|[1-5])\d$/.test(v) || 'This field must be a valid time.',
    ],
    endAt: [
      () => !(this.startAt === '') || 'Please fill the field above first.',
      (v: string) => !!v || 'End At field is required.',
      (v: string) => !v || /^(?:0?|1|2(?=[0-3]))\d:(?:0?|[1-5])\d$/.test(v) || 'This field must be a valid time.',
    ],
    breakDuration: [
      (v: number) => !!v || 'This field is required.',
      (v: number) => (v === 30 || v === 60) || 'The field value is not valid.',
    ],
    textColor: [
      (v: string) => !!v || 'Text Color field is required.',
      (v: string) => !v || /^(#([a-fA-F0-9]){3})$|^(#([a-fA-F0-9]){6})$|^(#([a-fA-F0-9]){8})$/.test(v) || 'This field must be a HEX color.',
    ],
    dayType: [
      (v: string) => !!v || 'This field is required.',
      (v: string) => {
        // @ts-ignore
        if (!Object.values(ShiftDayType).includes(v)) {
          return 'The field value is not valid.';
        }

        return true;
      },
    ],
    automations: [
      (v: boolean) => {
        if (this.dayType !== ShiftDayType.WORK && v) {
          return 'Automations cannot be applied on this Shift Type';
        }

        return true;
      },
    ],
  };
}
